class ContentScrollerItem extends HTMLElement {
  constructor() {
    super();

    const scroller_media_items = this.closest(".content-scroller").querySelectorAll(".content-scroller-media-item");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const third_of_viewport = window.innerHeight / 3;

        const top_enters = (entry.boundingClientRect.top < third_of_viewport && entry.boundingClientRect.top > 0);

        const bottom_enters = (entry.boundingClientRect.bottom > third_of_viewport && entry.boundingClientRect.bottom < window.innerHeight);

        if (entry.isIntersecting && (top_enters || bottom_enters)) {
          scroller_media_items.forEach((element) => {
            element.classList.remove("state--active");
          });

          scroller_media_items[this.dataset.index].classList.add("state--active");
        }
      });
    }, {
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    observer.observe(this);
  }
}

customElements.define("content-scroller-item", ContentScrollerItem);

class ContentSlider extends HTMLElement {
  constructor() {
    super();

    const id = this.getAttribute("id");

    const slider = new Flickity(this, {
      imagesLoaded: true,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      loop: true,
      fade: true
    });

    slider.on("change", (index) => {
      document.dispatchEvent(new CustomEvent("contentslider:" + id + ":change", {
        detail: {
          index: index
        }
      }));
    });
  }
}

customElements.define("content-slider", ContentSlider);

class ContentSliderMedia extends HTMLElement {
  constructor() {
    super();

    const id = this.getAttribute("id");

    const slider = new Flickity(this, {
      imagesLoaded: true,
      draggable: false,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      loop: true,
      fade: true
    });

    document.addEventListener("contentslider:" + id + ":change", (event) => {
      slider.select(event.detail.index);
    });

    slider.on("change", (index) => {
      const inactive_video_element = this.querySelector(".flickity-slider > div:not(.is-selected) video-inline");
      inactive_video_element.stop();
    });
  }
}

customElements.define("content-slider-media", ContentSliderMedia);
